// The game on another site's servers: a separate build per site (npm run
// build:crazygames), hosted by them and shown in their frame. Our own site and
// the itch.io page (which frames our site) are not portals. (No imports here:
// the audio and the paths read it while the app is still loading. The site's
// SDK is in portal.ts.)
//
// A portal build:
//  - is the game app everywhere (the phone layout, also on a computer), since
//    the site's frame is small and 16:9 and the site has its own chrome
//  - plays on our servers like everyone else (online/net.ts)
//  - leaves out what the site does not allow: our sign-in, the Store and its
//    real-money eggs, Ranked (it needs an account), our fullscreen buttons,
//    links back to our site and to other games, our ads, the rooms' chat (no
//    word filter yet)
//  - tells the site's SDK when a round is being played and follows its mute
// (CrazyGames' rules: docs.crazygames.com/requirements, the Basic Launch.)

declare const __PORTAL__: string;
export type Portal = "crazygames";
// (the dev server: ?portal=crazygames draws the site's build, for the design
// labs; without their SDK, which only runs on their domains)
const devPortal = (): string | null => {
  try { return (import.meta as any).env?.DEV ? new URLSearchParams(window.location.search).get("portal") : null; } catch { return null; }
};
export const PORTAL: Portal | null = typeof __PORTAL__ === "string" && __PORTAL__ ? (__PORTAL__ as Portal) : devPortal() === "crazygames" ? "crazygames" : null;
export const ON_PORTAL = PORTAL !== null;

// The start screen's look in the site's frame on a computer
// (pages/lobby/start/FrameHome.tsx): B, the game menu (picked 2026-10-30).
// /debug/portal-lab compares them: ?pv=a|b|c, or ?pv=none for the phone's screen.
export const FRAME_LOOK: "a" | "b" | "c" | null = (() => {
  let v: string | null = null;
  try { v = new URLSearchParams(window.location.search).get("pv"); } catch { /* no window */ }
  if (v === "a" || v === "b" || v === "c") return v;
  return v === "none" || !ON_PORTAL ? null : "b";
})();

// A file from public/ (on a portal the build's base is "./": the site hosts it
// under a path of its own).
export function asset(path: string): string {
  const base = ((import.meta as any).env?.BASE_URL as string | undefined) ?? "/";
  return base.replace(/\/$/, "") + path;
}
